// extracted by mini-css-extract-plugin
export var divider = "_q1-0";
export var systemMessage = "_q1-1";
export var systemMessageWrapper = "_q1-2";